import React from 'react';
import { Button, Divider, Form } from 'semantic-ui-react';
import { change, Field, formValueSelector, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { find } from 'lodash';
import PhotoBoothModal from '../../../../../../../containers/PhotoBoothModal';
import {
  Tech3FileInput,
  Tech3Input,
  Tech3Select
} from '../../../../../../../components/FormElements';
import { required } from '../../../../../../../lib/FormValidators';

const occurrenceStimuliFormName = 'occurrenceStimuli';

const StimuliForm = props => {
  const onFileUploadChange = (event, newValue, previousValue, name) => {
    const fr = new FileReader();

    fr.onload = function() {
      // file is loaded
      const img = new Image();

      img.onload = function() {
        props.dispatch(change(occurrenceStimuliFormName, 'width', img.width));
        props.dispatch(change(occurrenceStimuliFormName, 'height', img.height));
      };

      img.src = fr.result; // is the data URL because called with readAsDataURL
    };

    fr.readAsDataURL(newValue);
  };

  return (
    <PhotoBoothModal {...props}>
      <Form onSubmit={props.handleSubmit}>
        {props.initialValues && props.initialValues.id ? (
          <h2>Edit Stimuli</h2>
        ) : (
          <h2>Create new Stimuli</h2>
        )}
        <Field
          label="Stimuli Name"
          name="name"
          type="text"
          placeholder="Stimuli Name..."
          component={Tech3Input}
          validate={[required]}
        />
        <Field
          label="Stimuli Description"
          name="description"
          type="text"
          placeholder="Stimuli Description..."
          component={Tech3Input}
          validate={[required]}
        />

        <Divider />

        <Field
          label="File"
          name="file"
          type="file"
          component={Tech3FileInput}
          validate={[required]}
          onChange={onFileUploadChange}
        />

        <Form.Group widths="equal">
          <Field
            label="Width"
            name="width"
            type="text"
            component={Tech3Input}
            validate={[required]}
          />
          <Field
            label="Height"
            name="height"
            type="text"
            component={Tech3Input}
            validate={[required]}
          />
        </Form.Group>

        <Divider section />

        <Form.Group widths="equal">
          <Field
            label="Software"
            name="software_id"
            options={props.software}
            placeholder="Choose Software..."
            component={Tech3Select}
            upward
            validate={[required]}
            onChange={(event, newValue, previousValue) => {
              props.dispatch(change(occurrenceStimuliFormName, 'version_id', ''));
            }}
          />
          <Field
            label="Version"
            name="version_id"
            options={props.versions}
            placeholder="Choose Version..."
            component={Tech3Select}
            upward
            validate={[required]}
          />
        </Form.Group>

        <Button type="submit" disabled={props.submitting}>
          Submit
        </Button>
      </Form>
    </PhotoBoothModal>
  );
};

StimuliForm.propTypes = {
  ...PhotoBoothModal.propTypes
};

StimuliForm.defaultProps = { ...PhotoBoothModal.defaultProps };

const stimuliForm = reduxForm({
  form: occurrenceStimuliFormName,
  enableReinitialize: true
})(StimuliForm);

export default connect(state => ({
  software: state.projects.software.map((software, i) => {
    return {
      key: `software_${software.id}`,
      text: software.name,
      value: software.id
    };
  }),

  versions: (() => {
    const occurrenceEventFormSelector = formValueSelector(occurrenceStimuliFormName);
    const softwareVersions = find(state.projects.software, {
      id: parseInt(occurrenceEventFormSelector(state, 'software_id'), 10)
    });

    if (!softwareVersions) return null;

    return softwareVersions.equipment_software_versions.map((version, i) => {
      return {
        key: version.id,
        text: version.version_name,
        value: version.id
      };
    });
  })()
}))(stimuliForm);



// WEBPACK FOOTER //
// ./src/scenes/projects/scenes/singleProject/components/experimentalDesign/modals/StimuliForm.js